import API from "../API";

export const getFingerprintData = async (): Promise<Array<any>> => {
  const result = await API.get("/fingerprintData/");

  return result.data;
};
